import {action, makeAutoObservable, observable, reaction} from 'mobx';
import {companyApi} from "../backend/CompanyApi";
import {BankAccountCode} from "../model/BankAccountCode";
import {selectedCompanyStore} from "./SelectedCompany";
import {AccountCodeDto} from "../model/AccountCodeDto";
import {Nil} from "../utils/Types";
import {logEvent} from "../utils/SentryUtils";
import {userInfoStore} from "./UserInfo";

class CompanyAccounts {
    @observable fetched: boolean = false;
    readonly bankAccounts = observable<BankAccountCode>([])
    readonly accounts = observable<AccountCodeDto>([])

    constructor() {
        makeAutoObservable(this);
    }

    @action
    public async refresh() {
        if (selectedCompanyStore.isSelected && userInfoStore.isAuthorized) {
            if (!this.fetched) {
                this.fetched = true;
                const selectedCompanyId = selectedCompanyStore.companyId;
                const bankCodesPromise = companyApi.fetchBankAccountCodes(selectedCompanyId);
                const accCodesPromise = companyApi.fetchAccountCodes(selectedCompanyId);
                this.bankAccounts.replace(await bankCodesPromise);
                this.accounts.replace(await accCodesPromise);
                logEvent("account", "Banks and accounts refreshed")
            }
        } else {
            this.bankAccounts.clear()
            this.accounts.clear()
            this.fetched = false;
        }
    }

    @action
    public async invalidate() {
        this.fetched = false;
    }

    public findByIban(iban: string, currency?: string): BankAccountCode | Nil {
        //#bank_account_code_match used on backend
        const byIbanOnly = this.bankAccounts.filter(it => it.iban === iban);
        if (byIbanOnly.length > 1 && currency) {
            return byIbanOnly.find(it => it.name.includes(currency))
        }
        return byIbanOnly.find(() => true)
    }
}

export const companyAccountsStore = new CompanyAccounts();
reaction(
        () => selectedCompanyStore.companyId,
        () => companyAccountsStore.invalidate()
)

reaction(
        () => userInfoStore.email,
        () => companyAccountsStore.invalidate()
)
